<template>
    <div class="echartsBox">
        <img src="@/assets/RN/gifdc.gif" class="imggif" alt="">
        <div ref="huanxing" id="huanxing" :style="{ width: '435px', height: '240px' }"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import 'echarts-gl';
require('echarts/lib/chart/bar.js');
require('echarts/lib/component/title.js');
require('echarts/lib/component/tooltip.js');
export default {
    name: 'template.scope21',
   
    mounted() {
        this.init();
    },
    watch: {
      
    },
    data() {
        return {
            title:'3d环形图-有问题-scope21',
            isList: true,
            timer: null,
            defaultdata: [
                { value1: '11-11', value2: '7', value3: '4' },
                { value1: '11-12', value2: '5', value3: '3' },
                { value1: '11-13', value2: '4', value3: '3' },
                { value1: '11-14', value2: '5', value3: '3' },
                { value1: '11-15', value2: '3', value3: '4' },
                { value1: '11-16', value2: '4', value3: '2' },
                { value1: '11-17', value2: '4', value3: '5' },
            ],
            valueMap: [
                { name: '零售', value: 40, itemStyle: { color: '#2B8EF3' }, opacity: '65%' },
                { name: '其他', value: 30, itemStyle: { color: '#9CBECF' }, opacity: '65%' },
                { name: '调拨', value: 20, itemStyle: { color: '#2C49B8' }, opacity: '65%' },
                { name: '纯销', value: 10, itemStyle: { color: '#3DBCBE' }, opacity: '65%' },
            ],
            exceldata: []
        }
    },
    methods: {
        init() {
            // console.log(this.valueMap, "454");
            // devicePixelRatio: 设备像素比，默认取浏览器的值window.devicePixelRatio
            let myChart = echarts.init(document.getElementById('huanxing'), null, { devicePixelRatio: 2 })
            // 传入数据生成 option
            let option = getPie3D(this.valueMap, 0.75, 10);
            myChart.setOption(option);

            // 生成模拟 3D 饼图的配置项
            function getPie3D(pieData, internalDiameterRatio, height) {
                let series = [];
                let sumValue = 0;
                let startValue = 0;
                let endValue = 0;
                let legendData = [];
                let k = typeof internalDiameterRatio !== 'undefined' ? (1 - internalDiameterRatio) / (1 + internalDiameterRatio) : 1 / 3;

                // 为每一个饼图数据，生成一个 series-surface 配置
                for (let i = 0; i < pieData.length; i++) {
                    sumValue += pieData[i].value;
                    let seriesItem = {
                        name: typeof pieData[i].name === 'undefined' ? `series${i}` : pieData[i].name,
                        type: 'surface',
                        parametric: true,
                        wireframe: {
                            show: false
                        },
                        pieData: pieData[i],
                        pieStatus: {
                            selected: false,
                            hovered: false,
                            k: k
                        },
                    }
                    if (typeof pieData[i].itemStyle != 'undefined') {

                        let itemStyle = {};

                        typeof pieData[i].itemStyle.color != 'undefined' ? itemStyle.color = pieData[i].itemStyle.color : null;
                        typeof pieData[i].itemStyle.opacity != 'undefined' ? itemStyle.opacity = pieData[i].itemStyle.opacity : null;

                        seriesItem.itemStyle = itemStyle;
                    }
                    series.push(seriesItem);
                }


                // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
                // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
                let linesSeries = [];
                for (let i = 0; i < series.length; i++) {
                    endValue = startValue + series[i].pieData.value;

                    series[i].pieData.startRatio = startValue / sumValue;
                    series[i].pieData.endRatio = endValue / sumValue;
                    series[i].parametricEquation = getParametricEquation(series[i].pieData.startRatio, series[i].pieData.endRatio, false, i === 0, k, height ? height : 10);

                    startValue = endValue;
                    legendData.push(series[i].name);
                }
                series = series.concat(linesSeries)
                // 设置一个 2D环形图,在环形图中间展示数据名称与数据值

                series.push({
                    // name: 'Access From',
                    type: 'pie',
                    // 环形图的内环与外环占比
                    radius: ['50%', '60%'],
                    // center: ['0%', '50%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'center',
                    },
                    itemStyle: {
                        // 控制2D环形图的显隐  0 隐藏 1 显示
                        opacity: 0
                    },
                    emphasis: {
                        label: {
                            show: true,
                            color: '#fff',
                            opacity: 1,
                            fontFamily: 'Source Han Sans CN',
                            fontWeight: 350,
                            fileSize: 50,
                            formatter: '{c} \n \n {b}',
                        }
                    },
                    labelLine: {
                        show: true
                    },
                    clockwise: false,
                    startAngle: 0,
                    data: pieData
                });
                // console.log(series, "series11");

                // 准备待返回的配置项，把准备好的 legendData、series 传入。
                let option = {
                    legend: {
                        data: legendData,
                        bottom: 0,
                        textStyle: {
                            color: 'white',
                            fontFamily: 'Source Han Sans CN',
                            fontSize: 14,
                        }
                    },
                    label: {
                        show: true
                    },
                    xAxis3D: {
                        min: -1,
                        max: 1
                    },
                    yAxis3D: {
                        min: -1,
                        max: 1
                    },
                    zAxis3D: {
                        min: -2,
                        max: 2
                    },
                    grid3D: {
                        show: false,
                        top: -16,
                        boxHeight: 4, //圆环的高度
                        viewControl: {//3d效果可以放大、旋转等，请自己去查看官方配置
                            alpha: 45,    // 调整视图角度
                            beta: -10,       // 调整视图角度
                            distance: 160,//调整视角到主体的距离，类似调整zoom
                            rotateSensitivity: 1, //设置为0无法旋转
                            zoomSensitivity: 1, //设置为0无法缩放
                            panSensitivity: 1, //设置为0无法平移
                            autoRotate: false
                        },
                        //后处理特效可以为画面添加高光、景深、环境光遮蔽（SSAO）、调色等效果。可以让整个画面更富有质感。
                        postEffect: {//配置这项会出现锯齿，请自己去查看官方配置有办法解决
                            enable: true,
                            bloom: {
                                enable: true,
                                bloomIntensity: 1
                            },
                            SSAO: {
                                enable: true,
                                quality: 'medium',
                                radius: 2
                            }
                        }
                    },
                    series: series
                };
                return option;
            }

            // startRatio（浮点数）: 当前扇形起始比例，取值区间[0, endRatio)
            // endRatio（浮点数）: 当前扇形结束比例，取值区间(startRatio, 1]
            // isSelected（布尔值）: 是否选中，效果参照二维饼图选中效果（单选）
            // isHovered（布尔值）: 是否放大，效果接近二维饼图高亮（放大）效果（未能实现阴影）
            // k（0~1之间的浮点数）：用于参数方程的一个参数，取值 0~1 之间，通过「内径 / 外径」的值换算而来。
            //height配置3d扇形高度
            function getParametricEquation(startRatio, endRatio, isSelected, isHovered, k, height) {
                // 计算
                let midRatio = (startRatio + endRatio) / 2;

                let startRadian = startRatio * Math.PI * 2;
                let endRadian = endRatio * Math.PI * 2;
                let midRadian = midRatio * Math.PI * 2;

                // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
                k = typeof k !== "undefined" ? k : 1 / 3;

                // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
                let offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
                let offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;

                // 计算高亮效果的放大比例（未高亮，则比例为 1）
                let hoverRate = isHovered ? 1.05 : 1;

                // 返回曲面参数方程
                return {
                    u: {
                        min: -Math.PI,
                        max: Math.PI * 3,
                        step: Math.PI / 32,
                    },
                    v: {
                        min: 0,
                        max: Math.PI * 2,
                        step: Math.PI / 20,
                    },
                    x: (u, v) => {
                        if (u < startRadian) {
                            return (
                                offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate
                            );
                        }
                        if (u > endRadian) {
                            return (
                                offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate
                            );
                        }
                        return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
                    },

                    y: (u, v) => {
                        if (u < startRadian) {
                            return (
                                offsetY +
                                Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate
                            );
                        }
                        if (u > endRadian) {
                            return (
                                offsetY +
                                Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate
                            );
                        }
                        return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
                    },

                    z: (u, v) => {
                        if (u < -Math.PI * 0.5) {
                            return Math.sin(u);
                        }
                        if (u > Math.PI * 2.5) {
                            return Math.sin(u);
                        }
                        return Math.sin(v) > 0 ? 1 * height : -1;
                    }
                }
            }

        },
    },
}
</script>

<style scoped>
.imggif {
    width: 350px;
    height: 350px;
    position: absolute;
    top: -20%;
    left: 9.5%;
    /* transform: translate(-50%, -50%); */
    /* z-index: -1; */
    transform: rotateX(42deg) rotateZ(180deg);
    filter: hue-rotate(300deg) saturate(65%);
    /* mix-blend-mode: screen; */
    /* pointer-events: none;
    opacity: 1;
    transform: perspective(0px)rotateX(0deg)rotateY(0deg)rotateZ(0deg)scaleX(1)scaleY(-1)translate3d(0px,0px,0px); */
}

.echartsBox {
    width: 435px;
    height: 240px;
    position: relative;
    overflow: hidden;
    /* background-color: black; */
}

.tmain2 {
    /* margin-left: 35px; */
    width: 480px;
    height: 240px;
    margin-left: 13px;
}
</style>